var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChatIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "chat_icon_",
    "data-name": "chat icon ",
    transform: "translate(-35 -776)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18915",
    "data-name": "Rectangle 18915",
    width: 24,
    height: 24,
    transform: "translate(35 776)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "chat-bubble",
    transform: "translate(37 778)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59227",
    "data-name": "Path 59227",
    d: "M7,9H17a1,1,0,0,0,0-2H7A1,1,0,0,0,7,9Zm0,4H17a1,1,0,0,0,0-2H7a1,1,0,0,0,0,2Z",
    transform: "translate(-2 -2)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59228",
    "data-name": "Path 59228",
    d: "M5,2H19a3,3,0,0,1,3,3V15a3,3,0,0,1-3,3H7.414L3.707,21.707A1,1,0,0,1,2,21V5A3,3,0,0,1,5,2ZM7,13H17a1,1,0,0,0,0-2H7a1,1,0,0,0,0,2ZM7,9H17a1,1,0,0,0,0-2H7A1,1,0,0,0,7,9Z",
    transform: "translate(-2 -2)",
    fill: "#348fbd"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatIcon);
export default __webpack_public_path__ + "static/media/chatIcon.1dc75ce6fd2f37b1e9e0d38f03b3e0b8.svg";
export { ForwardRef as ReactComponent };